import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/header';
import { retrieveMineData } from '../Utility/ConsumeToken/consumeToken';
import { getFileVizit } from '../Utility/ManageFiles/fileUtils';

const VizitPage = () => {
  const [loaded, setLoaded] = useState(false);
  const [fileName, setFileName] = useState('');
  const [isSaving, setIsSaving] = useState(false); // bottone in loading
  const fileNameRef = useRef(fileName);
  const graphPanelRef = useRef(null);
  const abortPollRef = useRef(false);

  useEffect(() => {
    fileNameRef.current = fileName;
  }, [fileName]);

  useEffect(() => {
    retrieveMineData()
      .then(data => {
        localStorage.setItem('mineData', JSON.stringify(data));
      })
      .catch(err => {
        console.error('Error Token:', err);
        alert('Error Token');
      });

    window.onVizitLoad = () => {
      console.log('Host page says: Vizit Loaded');
      setLoaded(true);
    };

    const sleep = (ms) => new Promise(res => setTimeout(res, ms));

    /**
     * Polling: prova a leggere il file finché non compare.
     * Forziamo l'estensione .json perché lo storage salva come <name>.json
     * e l'endpoint GET_FILE risponde con {result:-1, output:"FILE_DOES_NOT_EXISTS"} quando non c'è.
     */
    const pollForFile = async (rawName, intervalMs = 2000) => {
      const storedName = rawName.endsWith('.json') ? rawName : `${rawName}.json`;
      while (!abortPollRef.current) {
        try {
          const apitoken = await retrieveMineData();
          const data = await getFileVizit('VIZITFS', storedName, apitoken);
          // Successo robusto: result === 1
          if (data && data.result !== -1) {
            return true; // trovato
          }
          // Se result === -1 e output === "FILE_DOES_NOT_EXISTS", continuiamo a pollare
        } catch (e) {
          // errore temporaneo o rete: riprova
        }
        await sleep(intervalMs);
      }
      return false; // interrotto per unmount
    };

    window.onStateSupportEvidenceHandler = async (se) => {
      try {
        const name = fileNameRef.current.trim();
        if (!name) {
          alert('Please enter a valid filename to save graph');
          setIsSaving(false);
          return;
        }

        const raw = localStorage.getItem('mineData');
        const mine = raw ? JSON.parse(raw) : {};
        if (!mine._id) {
          alert('Token Error. Go to login.');
          setIsSaving(false);
          return;
        }

        const payload = {
          serviceName: 'STORE_JSON',
          IDD: mine._id,
          Token: '000111',
          jSonData: se,
          fileName: name, // lasciamo il nome "base": lo storage aggiunge .json
        };

        // 1) Salvataggio (come prima). Non fermiamo il flow se fallisce: polliamo comunque.
        try {
          const resp = await fetch('https://vizitfs.softmining.it/fs.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          if (!resp.ok) {
            console.error('Request Error during save');
          } else {
            const serverData = await resp.json();
            console.log('Server (save):', serverData);
          }
        } catch (saveErr) {
          console.error('Save error:', saveErr);
          // Continuiamo comunque il polling
        }

        // 2) Poll finché il file non risulta nello storage (usa <name>.json)
        const found = await pollForFile(name);

        if (found) {
          alert('File is now available in Vizit Storage.');
          setIsSaving(false);
        }
        // Se non found è perché è stato unmountato: non toccare lo stato qui.
      } catch (error) {
        console.error('Errore:', error);
        // Non fermiamo il loading qui (l’utente vuole chiuderlo solo quando il file è trovato),
        // tranne i casi di validazione già gestiti sopra.
      }
    };

    // Caricamento script Vizit
    const script = document.createElement('script');
    script.src = 'https://newroad-ws.biovista.com/vizit/vizit/vizit.nocache.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      abortPollRef.current = true; // stop polling all’unmount
      document.body.removeChild(script);
      delete window.onVizitLoad;
      delete window.onStateSupportEvidenceHandler;
    };
  }, []);

  const getSupportingEvidence = () => {
    if (isSaving) return; // disabilitato durante loading
    if (window.vizit && window.vizit.getStateSupportingEvidence) {
      setIsSaving(true); // entra SUBITO in loading
      window.vizit.getStateSupportingEvidence(window.onStateSupportEvidenceHandler);
    } else {
      alert('Vizit is not ready.');
      setIsSaving(false);
    }
  };

  return (
    <>
      <Header />
        <div className="riga headerTools">
          <h3 className="titolo titoloFeature">Biovista Vizit</h3>
          <p className="text description" style={{ marginBottom: '5px' }}>
            Vizit is a semantic analysis tool developed by our partners from Biovista (
            <a href="https://www.biovista.com/" target="_blank" rel="noopener noreferrer">www.biovista.com</a>), enabling visual and interactive exploration of millions of scientific articles. It allows users to uncover relationships and insights across vast datasets, facilitating deeper understanding of complex research domains.
          </p>
          <div className="spaceGraph"></div>
          <input
            type="text"
            placeholder="Enter Graph name..."
            value={fileName}
            onChange={e => setFileName(e.target.value)}
            style={{ padding: '0.5em', width: '250px', marginRight: '1em' }}
          />
          <button
            className="button"
            style={{ padding: '0.5em 1em' }}
            disabled={!loaded || isSaving}
            onClick={getSupportingEvidence}
          >
            {isSaving ? 'Loading...' : 'Save Graph in Vizit Storage'}
          </button>
          <div
            id="bv-graphpanel"
            ref={graphPanelRef}
            style={{ margin: '10px 0 0 0', width: '100%', height: '66vh', border: '1px solid #0583B3' }}
          />
        </div>
        <div className="spaceGraph"></div>
    </>
  );
};

export default VizitPage;
